webpackJsonp([80],{

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1270);


/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _de = __webpack_require__(786);

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('de', _de2.default);

/***/ })

},[1269]);


// WEBPACK FOOTER //
// app/datetime.de-e8de505ef96b1422b46e.js